"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("../constant");

var _constant2 = require("./constant");

var _contextualSearchWidget = _interopRequireDefault(require("./contextualSearchWidget.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CSWContainer = _styledComponents.default.div.withConfig({
  displayName: "ContextualSearchWidget__CSWContainer",
  componentId: "sc-l1lu1o-0"
})(function (_ref) {
  var isMobile = _ref.isMobile,
      theme = _ref.theme;
  return "\n    max-height: 450px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    margin-bottom: ".concat(theme.space.semi, ";\n\n    #airasia-contextual-widget > div:first-child {\n      margin-top: ").concat(theme.space.normal, ";\n    }\n   \n    /* width */\n    ::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n      background: ").concat(theme.colors.greyMedium, ";\n      border-radius: ").concat(theme.borderRadius.normal, ";\n    }\n\n    ").concat(isMobile ? "\n          padding: 0 ".concat(theme.space.small, ";\n          max-height: 100%;\n         ") : '', "\n  ");
});

var ContextualSearchWidget = function ContextualSearchWidget(props) {
  var url = props.url,
      token = props.token,
      config = props.config,
      scriptletVersion = props.scriptletVersion,
      environment = props.environment,
      theme = props.theme;

  var _useState = (0, _react.useState)(_constant2.DEFAULT_URL[_constant2.ENVIRONMENTS[environment]]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      aggregatedURL = _useState2[0],
      setAggregatedURL = _useState2[1];

  var _useState3 = (0, _react.useState)(_objectSpread(_objectSpread({}, _constant2.DEFAULT_CONFIG), config)),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      aggregatedConfig = _useState4[0],
      setAggregatedConfig = _useState4[1];

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  (0, _react.useEffect)(function () {
    if (url) {
      setAggregatedURL(url);
    } else {
      setAggregatedURL(_constant2.DEFAULT_URL[_constant2.ENVIRONMENTS[environment]]);
    }
  }, [url, environment]);
  (0, _react.useEffect)(function () {
    setAggregatedConfig(_objectSpread(_objectSpread({}, _constant2.DEFAULT_CONFIG), config));
  }, [config]);

  var addJqueryScript = function addJqueryScript() {
    if (typeof window === 'undefined') {
      return;
    }

    if (window.jQuery) {
      return;
    }

    var tag = document.createElement('script');
    tag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
    document.head.appendChild(tag);
  };

  var addScriptlet = function addScriptlet() {
    var src = "https://static.airasia.com/cosmos/phoenix/".concat(scriptletVersion, "/scriptlet.js.gz");
    var scriptlet = document.querySelector("script[src='".concat(src, "']"));

    if (scriptlet) {
      return;
    }

    var tag = document.createElement('script');
    tag.setAttribute('async', '');
    tag.setAttribute('type', 'application/javascript');
    tag.src = src;
    document.body.appendChild(tag);
  };

  (0, _react.useEffect)(function () {
    addJqueryScript();
    addScriptlet(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var getMain = function getMain() {
    var viewport = aggregatedConfig.viewport;
    return /*#__PURE__*/_react.default.createElement(CSWContainer, {
      isMobile: viewport === _constant.DEVICE_TYPE.MOBILE
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "aa-phoenix",
      id: "airasia-contextual-widget",
      "data-url": aggregatedURL,
      "data-token": token,
      "data-config": JSON.stringify(aggregatedConfig)
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

ContextualSearchWidget.propTypes = _contextualSearchWidget.default.PropTypes;
ContextualSearchWidget.defaultProps = _contextualSearchWidget.default.DefaultProps;
var _default = ContextualSearchWidget;
exports.default = _default;